import { commonActionsReducer } from '../../common/actions';
import { SUBCATEGORIES } from '../../common/categories';
import { SYSLOG_FIELDS_V2, WEBHOOK_FIELDS, EMAIL_FIELDS } from '../../common/fields';
import { buildField } from '../../common/utils';
import * as actions from './AlertsManagementActions';
import { v1 as uuidV1 } from 'uuid';

const { WEBHOOK, SYSLOG_SERVER, EMAIL, CUSTOM_INTEGRATIONS } = SUBCATEGORIES;
const { WEBHOOKS } = WEBHOOK_FIELDS;
const { SYSLOG_SERVERS } = SYSLOG_FIELDS_V2;
const { EMAILS } = EMAIL_FIELDS;

export const fieldsReducer = (state, action) => {
    switch (action.type) {
        case actions.ADD_WEBHOOK:
            return addWebhook(state, WEBHOOK.ID, WEBHOOKS.ID, action.payload);
        case actions.REMOVE_WEBHOOK:
            return removeWebhook(state, WEBHOOK.ID, WEBHOOKS.ID, action.payload);
        case actions.UPDATE_WEBHOOK:
            return updateWebhook(state, WEBHOOK.ID, WEBHOOKS.ID, action.payload.id, action.payload.value);
        case actions.ADD_SYSLOG_SERVER:
            return addSyslog(state, SYSLOG_SERVER.ID, SYSLOG_SERVERS.ID, action.payload);
        case actions.REMOVE_SYSLOG_SERVER:
            return removeSyslog(state, SYSLOG_SERVER.ID, SYSLOG_SERVERS.ID, action.payload);
        case actions.UPDATE_SYSLOG_SERVER:
            return updateSyslog(state, SYSLOG_SERVER.ID, SYSLOG_SERVERS.ID, action.payload.id, action.payload.value);
        case actions.ADD_EMAIL:
            return addEmail(state, EMAIL.ID, EMAILS.ID, action.payload);
        case actions.REMOVE_EMAIL:
            return removeEmail(state, EMAIL.ID, EMAILS.ID, action.payload);
        case actions.UPDATE_EMAIL:
            return updateEmail(state, EMAIL.ID, EMAILS.ID, action.payload.id, action.payload.value);
        case actions.UPDATE_INTEGRATIONS_EVENT_CONF:
            return updateIntegrationsEventConf(
                state,
                CUSTOM_INTEGRATIONS.ID,
                CUSTOM_INTEGRATIONS.ID,
                action.payload.value
            );
        default:
            return commonActionsReducer(state, action, initFieldsState);
    }
};

const addWebhook = (state, tab, field, webhook) => {
    const newWebhookId = uuidV1();
    webhook.id = newWebhookId;
    const newState = { ...state };
    const webhooksField = newState[tab].fields[field];
    webhooksField.value = { ...webhooksField.value };
    webhooksField.value[newWebhookId] = webhook;
    webhooksField.isDirty = true;
    return newState;
};

const updateWebhook = (state, tab, field, webhookId, webhookData) => {
    const newState = { ...state };
    const webhooksField = newState[tab].fields[field];
    webhooksField.value = { ...webhooksField.value };
    webhooksField.value[webhookId] = webhookData;
    webhooksField.isDirty = true;
    return newState;
};

const removeWebhook = (state, tab, field, webhookId) => {
    const newState = { ...state };
    const webhooksField = newState[tab].fields[field];
    webhooksField.value = { ...webhooksField.value };
    delete webhooksField.value[webhookId];
    webhooksField.isDirty = true;
    return newState;
};

const addSyslog = (state, tab, field, syslogServer) => {
    const newSyslogId = uuidV1();
    syslogServer.id = newSyslogId;
    const newState = { ...state };
    const syslogsField = newState[tab].fields[field];
    syslogsField.value = { ...syslogsField.value };
    syslogsField.value[newSyslogId] = syslogServer;
    syslogsField.isDirty = true;
    return newState;
};

const updateSyslog = (state, tab, field, syslogId, syslogData) => {
    const newState = { ...state };
    const syslogsField = newState[tab].fields[field];
    syslogsField.value = { ...syslogsField.value };
    syslogsField.value[syslogId] = syslogData;
    syslogsField.isDirty = true;
    return newState;
};
const updateIntegrationsEventConf = (state, tab, field, IntegrationsEventConfData) => {
    const newState = { ...state };
    const confField = newState[tab].fields[field];
    confField.value = IntegrationsEventConfData;
    confField.isDirty = true;
    return newState;
};

const removeSyslog = (state, tab, field, syslogId) => {
    const newState = { ...state };
    const syslogsField = newState[tab].fields[field];
    syslogsField.value = { ...syslogsField.value };
    delete syslogsField.value[syslogId];
    syslogsField.isDirty = true;
    return newState;
};

const addEmail = (state, tab, field, email) => {
    const newEmailId = uuidV1();
    email.id = newEmailId;
    const newState = { ...state };
    const emailsField = newState[tab].fields[field];
    emailsField.value = { ...emailsField.value };
    emailsField.value[newEmailId] = email;
    emailsField.isDirty = true;
    return newState;
}

const updateEmail = (state, tab, field, emailId, emailData) => {
    const newState = { ...state };
    const emailsField = newState[tab].fields[field];
    emailsField.value = { ...emailsField.value };
    emailsField.value[emailId] = emailData;
    emailsField.isDirty = true;
    return newState;
}

const removeEmail = (state, tab, field, emailId) => {
    const newState = { ...state };
    const emailsField = newState[tab].fields[field];
    emailsField.value = { ...emailsField.value };
    delete emailsField.value[emailId];
    emailsField.isDirty = true;
    return newState;
}

export const initFieldsState = ({ settings }) => {
    return {
        [WEBHOOK.ID]: {
            id: WEBHOOK.ID,
            name: WEBHOOK.NAME,
            fields: {
                [WEBHOOKS.ID]: buildField(WEBHOOKS, settings.webhooks || {})
            },
            validators: {}
        },
        [SYSLOG_SERVER.ID]: {
            id: SYSLOG_SERVER.ID,
            name: SYSLOG_SERVER.NAME,
            fields: {
                [SYSLOG_SERVERS.ID]: buildField(SYSLOG_SERVERS, settings.SyslogServers || {})
            },
            validators: {}
        },
        [EMAIL.ID]: {
            id: EMAIL.ID,
            name: EMAIL.NAME,
            fields: {
                [EMAILS.ID]: buildField(EMAILS, settings.EmailNotificationsSettings || {})
            },
            validators: {}
        },
        [CUSTOM_INTEGRATIONS.ID]: {
            id: CUSTOM_INTEGRATIONS.ID,
            name: CUSTOM_INTEGRATIONS.NAME,
            fields: {
                [CUSTOM_INTEGRATIONS.ID]: buildField(CUSTOM_INTEGRATIONS, settings.IntegrationsEventConf || {})
            },
            validators: {}
        }
    };
};

export const mapToSettings = (saveAll, selectedTab, fields) => {
    const newSettings = {};

    if (saveAll || selectedTab === WEBHOOK.ID) {
        const webhooks = fields[WEBHOOK.ID];
        newSettings.webhooks = webhooks.fields[WEBHOOKS.ID].value;
    }
    if (saveAll || selectedTab === SYSLOG_SERVER.ID) {
        const syslogServers = fields[SYSLOG_SERVER.ID];
        newSettings.SyslogServers = syslogServers.fields[SYSLOG_SERVERS.ID].value;
    }
    if (saveAll || selectedTab === EMAIL.ID) {
        const emails = fields[EMAIL.ID];
        newSettings.EmailNotificationsSettings = emails.fields[EMAILS.ID].value;
    }
    if (saveAll || selectedTab === CUSTOM_INTEGRATIONS.ID) {
        const integrationsEventConf = fields[CUSTOM_INTEGRATIONS.ID];
        newSettings.IntegrationsEventConf = integrationsEventConf.fields[CUSTOM_INTEGRATIONS.ID].value;
    }
    return newSettings;
};
